import React, { lazy, memo, Suspense } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useDeviceDetect } from './helpers/util';
import { store } from './store';
import OAuthPage from './components/oauth/OAuthPage';
const AppDsk = lazy(() => import('./App.dsk'));
const AppMob = lazy(() => import('./App.mob'));

export function MerchantRoutes() {
    const { pathname } = useLocation();
    const device = useDeviceDetect();
    if (pathname === '/oauth/authorize' || pathname === '/oauth/connections')
        return (
            <OAuthPage
                key={pathname}
                portalToken={pathname === "/oauth/connections" ? store.getState().auth?.info?.token : undefined}
                manage={pathname === '/oauth/connections'}
            />
        );
    return (
        <Suspense fallback={<p role="status">Loading…</p>}>
            {device.isDesktop() ? <AppDsk /> : <AppMob />}
        </Suspense>
    );
}
const DeviceWrap = () => (
    <Router basename={process.env.PUBLIC_URL}>
        <MerchantRoutes />
    </Router>
);
export default memo(DeviceWrap);
